export default __webpack_public_path__ + "media/doctorsRecommend.1ea6e9697c16e96a9114945cbbbfe32b.webp";